<ng-container *ngIf="!circleLoading; else loadingSpinner">
  <div class="animation-container">
    <div class="loadingio-spinner-message-bs4v748lf9j">
      <div class="ldio-i34nyigc4n">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loadingSpinner>
  <div class="animation-container">
    <div class="loadingio-spinner-message-bs4v748lf9j">
        <div class="spinner"></div>
    </div>
  </div>
</ng-template>